export default __webpack_public_path__ + "static/media/services-educatifs-mobilite.294f3875.jpg";